import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckboxCheckedEnabled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6 0C2.68629 0 0 2.68629 0 6V14C0 17.3137 2.68629 20 6 20H14C17.3137 20 20 17.3137 20 14V6C20 2.68629 17.3137 0 14 0H6ZM12.9401 6.99987C13.2801 6.65987 13.8401 6.65987 14.1801 6.99987C14.5201 7.34987 14.5201 7.89987 14.1801 8.23987L9.43009 12.9899C9.26009 13.1599 9.04009 13.2399 8.81009 13.2399C8.59009 13.2399 8.37009 13.1599 8.20009 12.9899L5.82009 10.6199C5.48009 10.2699 5.48009 9.71987 5.82009 9.37987C6.16009 9.03987 6.72009 9.03987 7.06009 9.37987L8.81009 11.1299L12.9401 6.99987Z",
		fill: "#4F49BA"
	})
});
export default SvgCheckboxCheckedEnabled;
